<template>
  <div :class="{ 'isDark': darkmode, 'disabled': !isPowerOn }">
    <i v-if="noSignal > 60" class="fas fa-wifi" style="color: #dc3545" />
    <i v-else class="fas fa-satellite-dish" />
    <span :style="`color: ${powerColor};`">'{{ timeSince }}</span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
  props: {
    darkmode: {
      type: Boolean,
    },
    device: {
      type: Number,
      required: true,
    },
  },
  computed: {
    ...mapGetters([
      'positions'
    ]),
    // time sinceLast
    noSignal() {
      return moment().diff(moment(this.positions[this.device].deviceTime), 'minutes')
    },
    timeSince() {
      let time = moment().diff(moment(this.positions[this.device].fixTime), 'minutes')
      if (time > 60) { return `60+` } else { return time }
    },
    powerColor() {
      if (this.timeSince < 30) {
        return `inherit` // green success
      } else
        if (this.timeSince < 60) {
          return `#ffc107` // yellow warning
        } else
          return `#dc3545` // red danger
    },
    isPowerOn() {
      return this.positions[this.device].attributes.alarm != "powerOff"
    },
  },
}
</script>

<style lang="scss" scoped>
span {
  padding-left: 5px;
}

.isDark {
  text-shadow: 0 0 5px #000, 0 0 5px #000, 0 0 5px #000, 0 0 5px #000;
}

.diabled {
  opacity: 0.3
}
</style>